import api from "../../../api/axios";

// Feature-local wrappers for ClientPreference nested endpoints
// (CRM-CLIENT-CONTACTS-MATCHING-A1).
//
// Endpoints:
//   GET    /api/crm/clients/{clientId}/preferences/
//   PUT    /api/crm/clients/{clientId}/preferences/  (upsert)
//   DELETE /api/crm/clients/{clientId}/preferences/  (204)
//
// Stateless request wrappers — no cache, no retry, no invalidation.

export const getPreferences = (clientId, { signal } = {}) =>
  api
    .get(`/crm/clients/${clientId}/preferences/`, { signal })
    .then((res) => res.data);

export const putPreferences = (clientId, data) =>
  api
    .put(`/crm/clients/${clientId}/preferences/`, data)
    .then((res) => res.data);

export const deletePreferences = (clientId) =>
  api
    .delete(`/crm/clients/${clientId}/preferences/`)
    .then((res) => res.data);
